import { jsxs, jsx } from 'react/jsx-runtime';
import { Body } from '../Body/Body.esm.js';
import { Timestamp } from '../Timestamp/Timestamp.esm.js';
import { useCommonImage } from './ChatMessage.hooks.esm.js';
import chatMessageStyles from './ChatMessage.styles.esm.js';

const ChatMessage = ({ variant, inverse = false, type = "text", message, image, timestamp, showTimestamp = true, className, bubbleClassName, timestampClassName, }) => {
    const { root, bubble, imageContainer, timestamp: tsCls, text, image: imgCls, } = chatMessageStyles({
        variant,
        inverse,
    });
    const renderedImage = useCommonImage(image, imgCls());
    return (jsxs("div", { className: root({ class: className }), "data-variant": variant, "data-inverse": inverse, children: [showTimestamp && (jsx(Body, { inverse: inverse, size: "xs", className: timestampClassName, children: jsx(Timestamp, { inverse: inverse, value: timestamp || "" }) })), type === "text" && message && (jsx("div", { className: bubble({ class: bubbleClassName }), role: "group", "aria-roledescription": "chat message", children: jsx(Body, { className: text(), size: "md", children: message }) })), type === "image" && (jsx("div", { className: imageContainer(), children: renderedImage }))] }));
};

export { ChatMessage, ChatMessage as default };
